// In-game keyboard cheatsheet. Always-visible compact strip bottom-left,
// expanded "?" panel toggled with H. Auto-hides after 8s on first show so
// returning players don't have to look at it forever.

const STORAGE_KEY = 'racing.controlsSeen';

export class ControlsHelp {

	constructor() {

		this._injectStyles();

		this.strip = document.createElement( 'div' );
		this.strip.id = 'controls-strip';
		this.strip.innerHTML =
			'<span class="k">WASD</span> drive ' +
			'<span class="k">Space</span> nitrous ' +
			'<span class="k">H</span> help';
		document.body.appendChild( this.strip );

		this.panel = document.createElement( 'div' );
		this.panel.id = 'controls-panel';
		this.panel.innerHTML =
			'<h3>CONTROLS</h3>' +
			'<div><span class="k">W A S D</span> / <span class="k">↑ ← ↓ →</span> drive · steer</div>' +
			'<div><span class="k">S</span> / <span class="k">↓</span> brake · reverse</div>' +
			'<div><span class="k">Space</span> / <span class="k">Shift</span> nitrous boost</div>' +
			'<div><span class="k">drift</span> turn hard at high speed (no separate handbrake)</div>' +
			'<div><span class="k">gamepad</span> stick · triggers · <span class="k">A</span> for boost</div>' +
			'<div><span class="k">H</span> hide this panel</div>';
		document.body.appendChild( this.panel );
		this.panel.style.display = 'none';

		this._panelVisible = false;
		this._handler = ( e ) => {

			if ( e.code === 'KeyH' && ! e.repeat ) this.toggle();

		};
		window.addEventListener( 'keydown', this._handler );

		// Show panel for new players only (8s auto-hide).
		if ( ! localStorage.getItem( STORAGE_KEY ) ) {

			localStorage.setItem( STORAGE_KEY, '1' );
			this.toggle( true );
			setTimeout( () => {

				if ( this._panelVisible ) this.toggle( false );

			}, 8000 );

		}

	}

	toggle( force ) {

		this._panelVisible = typeof force === 'boolean' ? force : ! this._panelVisible;
		this.panel.style.display = this._panelVisible ? 'block' : 'none';

	}

	_injectStyles() {

		if ( document.getElementById( 'controls-help-css' ) ) return;
		const css = document.createElement( 'style' );
		css.id = 'controls-help-css';
		css.textContent = `
			#controls-strip {
				position: absolute; bottom: 12px; left: 12px;
				color: #fff; font: 500 12px -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
				background: rgba(0,0,0,0.45); padding: 7px 11px; border-radius: 999px;
				z-index: 10; user-select: none; pointer-events: none;
				backdrop-filter: blur(8px); -webkit-backdrop-filter: blur(8px);
				opacity: 0.85;
			}
			#controls-strip .k {
				display: inline-block; padding: 1px 6px; margin-right: 4px;
				background: rgba(255,255,255,0.12); border-radius: 4px;
				font-family: ui-monospace, monospace; font-size: 11px;
			}
			#controls-panel {
				position: absolute; bottom: 56px; left: 12px;
				color: #fff; font: 500 13px -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
				background: rgba(20,24,32,0.92); padding: 14px 18px; border-radius: 12px;
				min-width: 280px; line-height: 1.7; z-index: 11;
				border: 1px solid rgba(255,255,255,0.08);
				backdrop-filter: blur(8px); -webkit-backdrop-filter: blur(8px);
				box-shadow: 0 12px 32px rgba(0,0,0,0.4);
				user-select: none; pointer-events: none;
			}
			#controls-panel h3 { margin: 0 0 8px; font-size: 11px; letter-spacing: 0.08em; opacity: 0.55; font-weight: 600; }
			#controls-panel .k {
				display: inline-block; padding: 1px 7px; margin-right: 4px;
				background: rgba(255,255,255,0.1); border: 1px solid rgba(255,255,255,0.15);
				border-radius: 4px; font-family: ui-monospace, monospace; font-size: 11px;
			}
		`;
		document.head.appendChild( css );

	}

	dispose() {

		window.removeEventListener( 'keydown', this._handler );
		this.strip?.remove();
		this.panel?.remove();

	}

}
